// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__UFArn","title":"styles_title__ddlTy","permissionText":"styles_permissionText__HYgm3","arrow":"styles_arrow__gsrZ5","rotate":"styles_rotate__7Ol5_"};